import { TableModule } from 'primeng/table';
import { Component, ViewChild, OnInit } from '@angular/core';
import {Router} from '@angular/router';
import {DashboardService} from '../../../../service/events/dashboard.service';
import {RequestHandler} from '../../../../service/OffService/request-handler';
import {RequestButtonTypes} from '../../../../common/components/request-button/request-button.component';
import {BaseView} from '../../../base-view';
import {environment} from '../../../../../environments/environment';
import moment from 'moment';
import { Filtering } from 'src/app/service/filtering/filtering';
import { StorageManager } from 'src/app/common/storage-manager.class';
import { MessageService } from 'primeng/api';
import { PedidosApiService } from 'src/app/service/api/pedidos-api.service';

import { PedidoModel } from 'src/app/models/visitas/pedido.model';
import { ColInterface } from 'src/app/common/components/common-list-table/col.interface';
import { ColStylesInterface } from 'src/app/common/components/common-list-table/col-styles.interface';

import { FormType } from '@fitogest/reactive-form-builder/interfaces';
import { VisitasPedidosListModalFormDefinition } from './visitas-pedidos-form/form-control/list-modal-form-definition';
@Component({
    selector: 'app-visitas-pedidos',
    standalone: false,
    templateUrl: './visitas-pedidos.component.html',
    styleUrls: ['./visitas-pedidos.component.scss'],
    providers: [MessageService]
})
export class VisitasPedidosComponent extends BaseView<PedidoModel> implements OnInit {
    public form: VisitasPedidosListModalFormDefinition | null = null;
    public serverUrl = environment.serverUrl;



    @ViewChild('table_cargos', {read: false, static: false}) table_cargos: TableModule = new TableModule();

    public appName = environment.appName;
    public applicationType = environment.features.applicationType;
    public currentUser = StorageManager.getUser();
    public clienteName = environment.features.clienteName;
    public fincaName = environment.features.fincaName;
    public userCanSeeClientes = environment.features.userCanSeeClientes;
    
    public filter: Filtering<PedidoModel> = new Filtering<PedidoModel>();
    
    public distributionOrder = [
        4, 3, 3, 3, 3, 3, 1
    ];

    public getRequest: RequestHandler<PedidoModel[]> = this.pedidosApi.pedidosGET;
    public deleteRequest: RequestHandler<PedidoModel> = this.pedidosApi.pedidosDELETE;

    public pathToForm = 'visitas-pedidos-form';
    public menuItemId = 'visitas-pedidos';

    public deleteRequestButtonType: RequestButtonTypes = RequestButtonTypes.DELETE;

    public override canShow: Record<string, boolean> = {};
    public override model: PedidoModel = {};
    
    public componentName = 'pedidos';

    public propiedad = {
        selected: ''
    };

    public cols: ColInterface[] = [
        {header: this.clienteName, field: 'cliente'},
        {header: this.fincaName, field: 'finca'},
        {header: 'Fecha Pedido', field: 'fecha_pedido'},
        {header: 'Fecha Entrega', field: 'fecha_entrega'},
        {header: 'Estado', field: 'estado'},
    ];

    constructor(
        public pedidosApi: PedidosApiService,
        private dashboard: DashboardService,
        private router: Router,
    ) {
        super(dashboard, pedidosApi.pedidosGET, pedidosApi.pedidosDELETE);
    }

    ngOnInit() {
        this.dashboard.setSubmenuItem('visitas', this.menuItemId);
        this.initFilter();
    }

    public globalConditionalStyle(value: string, col: ColInterface): ColStylesInterface {
        if (col.field === 'fecha_cad') {
            const fecha = moment(value, 'DD/MM/YYYY');
            const tresMesesAntes = moment(value, 'DD/MM/YYYY').subtract(3, 'months');
            const hoy = moment(moment().format('MM-DD-YYYY' + ' 00:00:00'));

            if (hoy.isSameOrAfter(tresMesesAntes) && hoy.isSameOrBefore(fecha)) {
                return {
                    rowStyle: {
                        backgroundColor: '#ff9a02',
                        textAlign: 'center'
                    }
                };
            } else if (hoy.isAfter(fecha)) {
                return {
                    rowStyle: {
                        backgroundColor: '#f44242',
                        textAlign: 'center'
                    }
                };
            } else {
                return {
                    rowStyle: {
                        textAlign: 'center'
                    }
                };  
            }
        }
        return{ textAlign: 'left'};
    }

    public globalVisualTransform(value: string, col: ColInterface): string {
        if ((col.field === 'fecha_entrega' || col.field === 'fecha_pedido') && !moment(value, 'DD/MM/YYYY').isValid()) {
            return '-';
        }
        return value;
    }

    public add() {
        if (!StorageManager.getClient() && this.userCanSeeClientes) {
            this.dashboard.openClientDialog();
        } else {
            this.router.navigate(['dashboard', 'crear-visita-pedido']);
        }
    }

    public edit(data: PedidoModel) {
        this.router.navigate(['dashboard', 'editar-visita-pedido', data.id]);
    }

    public duplicate(data: PedidoModel) {
        this.router.navigate(['dashboard', 'duplicar-visita-pedido', data.id]);
    }

    public override deleteRegister() {
        super.deleteRegister();
    }

    public override show(modal: string, data: PedidoModel) {
        super.show(modal, data);
        this.setModalForm(modal);
    }

  
    public handleFormValueChange() {

    }
    
    private initFilter(){
    }
    private setModalForm(modal: string): void {
        if (modal !== 'info' && modal !== 'delete') {
            return;
        }

        const formType = modal === 'delete' ? FormType.DELETION : FormType.INFORMATIVE;

        this.form = new VisitasPedidosListModalFormDefinition(formType, this.model, this);
    }

}
